export default __webpack_public_path__ + "static/media/InterviewerDetails.4d8f2600.svg";